import React, { useState, useRef, useCallback } from "react";
import styles from "./instructions.module.scss";
import { Link } from "@reach/router";

function Credits(props) {
  return (
    <div className={styles.page}>
      <p>
        This online game was developed by Conway McDermott and designed by
        Darius Ou. Non-Humans of Liverpool was created by Jack Tan in
        collaboration with:
      </p>
      <ul className={styles.participants}>
        <b>
          <u>PARTICIPANTS</u>
          <br />
          <br />
        </b>
        <li>Anna Reid - Plant Folk</li>
        <li>Corinne Jones - Insect Folk</li>
        <li>Dot Jackman - Natural Features Folk</li>
        <li>Evan Bray - Mammal Folk</li>
        <li>Tia Hume - Jennings - Water Folk</li>
        <li>Tom Oak - Bird Folk</li>
        <br />
        <br />
        <b>
          <u>FACT LEARNING TEAM</u>
        </b>
        <br />
        <br />
        <li>Carlos Marfil</li>
        <li>Jenny Watts</li>
        <li>Lucia Arias</li>
        <li>Neil Winterburn</li>
      </ul>

      <p className={styles.official}>
        Non-Humans of Liverpool is a collaborative work by artist Jack Tan,
        FACT's Digital Ambassadors; Anna Reid, Corinne Jones and Dot Jackman,
        and young people from Liverpool; Evan Bray, Tia Hume-Jennings and Tom
        Oak. Commissioned by FACT as part of Young at Art, a partnership between
        FACT, Open Eye Gallery and National Museums Liverpool and funded by Arts
        Council England's Celebrating Age programme and The Baring Foundation
        and with support from Medicash Foundation.
      </p>
      <nav>
        <ul className={styles.NavList}>
          <li className={styles.links}>
            <Link className={styles.linkButton} to={"/"}>
              HOME
            </Link>
          </li>
          <li className={styles.links}>
            <Link
              className={styles.linkButton}
              to={"/about/" + props.alpha + "/" + props.type + ""}
            >
              ABOUT
            </Link>
          </li>
          <li className={styles.links}>
            <Link
              className={styles.linkButton}
              to={"/inst/" + props.alpha + "/" + props.type + ""}
            >
              WHAT MAKES A GOOD MARKER?
            </Link>
          </li>
          {props.type !== "undefined" && props.type && (
            <li className={styles.links}>
              <Link
                className={styles.linkButton}
                to={"/" + props.alpha + "/" + props.type + ""}
              >
                BACK TO MAP
              </Link>
            </li>
          )}
        </ul>
      </nav>
      <br />
    </div>
  );
}

export default Credits;
